import React from 'react';
import { HexAlphaColorPicker, HexColorInput } from "react-colorful";

import getCheckboxField from '../../fields/checkbox';
import getSelectField from '../../fields/select';
import getRadioField from '../../fields/radio';

import getFonts from '../../../Functions/config/fonts';

const Content = ({ widget, handleInputChange, toggleColorPicker, setColorsAndPreview }) => {
    const { rentvine } = widget.htmlData;
    const fontOptions = getFonts();

    const setColorAndPreview = async (type, color) => {
        await setColorsAndPreview('layout', type, color);
    };

    const setSectionBg = async (color) => {
        await setColorAndPreview('layoutSectionBg', color);
    };

    const setRentColor = async (color) => {
        await setColorAndPreview('layoutRentColor', color);
    };

    const setRentBgColor = async (color) => {
        await setColorAndPreview('layoutRentBg', color);
    };

    const setDateColor = async (color) => {
        await setColorAndPreview('layoutDateColor', color);
    };

    const setDateBgColor = async (color) => {
        await setColorAndPreview('layoutDateBg', color);
    };

    const setTitleColor = async (color) => {
        await setColorAndPreview('layoutTitleColor', color);
    };

    const setAddressColor = async (color) => {
        await setColorAndPreview('layoutAddressColor', color);
    };

    const setBedColor = async (color) => {
        await setColorAndPreview('layoutBedColor', color);
    };

    const setBedIconColor = async (color) => {
        await setColorAndPreview('layoutBedIconColor', color);
    };

    const setBathColor = async (color) => {
        await setColorAndPreview('layoutBathColor', color);
    };

    const setBathIconColor = async (color) => {
        await setColorAndPreview('layoutBathIconColor', color);
    };

    const setDetailBtnColor = async (color) => {
        await setColorAndPreview('layoutDetailColor', color);
    };

    const setDetailBtnBgColor = async (color) => {
        await setColorAndPreview('layoutDetailBg', color);
    };

    const setApplyBtnColor = async (color) => {
        await setColorAndPreview('layoutApplyColor', color);
    };

    const setApplyBtnBgColor = async (color) => {
        await setColorAndPreview('layoutApplyBg', color);
    };

    return (
        <div className="mjwi-acc-panel-wrapper">
            <div className='mjwi-row'>    
                <div className='mjwi-col33'>
                    <label>
                        Layout
                    </label>                                    
                </div>
                <div className='mjwi-col66'>
                    <div className='mjwi-row mjwi-flex-end'>
                        <div className='mjwi-col25 mjwi-radio-svg'>
                            <label>
                                {getRadioField('layoutTemplate', 'eagle', rentvine.layout.layoutTemplate, handleInputChange)}
                                <svg width="50px" height="50px" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 9H21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </label>
                        </div>
                        <div className='mjwi-col25 mjwi-radio-svg'>
                            <label>
                                {getRadioField('layoutTemplate', 'hawk', rentvine.layout.layoutTemplate, handleInputChange)}
                                <svg width="50px" height="50px" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div className='mjwi-row'>    
                <div className='mjwi-col33'>
                    <label>
                        Font Family
                    </label>                                    
                </div>
                <div className='mjwi-col66'>
                    {getSelectField('layoutFontFamily', fontOptions, rentvine.layout.layoutFontFamily, handleInputChange)}
                </div>
            </div>

            <div className='mjwi-row'>
                <div className='mjwi-col50'>
                    <label>Columns</label>
                </div>
                <div className='mjwi-col50'>
                    <select
                        id="renttvineCol"
                        name="renttvineCol"
                        value={rentvine.renttvineCol}
                        onChange={handleInputChange}
                    >
                        <option value="1">1 column</option>
                        <option value="2">2 columns</option>
                        <option value="3">3 columns</option>
                        <option value="4">4 columns</option>
                    </select>
                </div>
            </div>

            <div className="mjwi-apfl-display-card-items">
                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('layoutRent', rentvine.layout.layoutRent, handleInputChange)}
                            Rent
                        </label>
                    </div>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('layoutDate', rentvine.layout.layoutDate, handleInputChange)}
                            Date
                        </label>
                    </div>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('layoutTitle', rentvine.layout.layoutTitle, handleInputChange)}
                            Title
                        </label>
                    </div>
                </div>

                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('layoutAddress', rentvine.layout.layoutAddress, handleInputChange)}
                            Address
                        </label>
                    </div>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('layoutBeds', rentvine.layout.layoutBeds, handleInputChange)}
                            Beds
                        </label>
                    </div>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('layoutBaths', rentvine.layout.layoutBaths, handleInputChange)}
                            Baths
                        </label>
                    </div>
                </div>

                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('layoutDetail', rentvine.layout.layoutDetail, handleInputChange)}
                            Details
                        </label>
                    </div>
                    <div className='mjwi-col33'>
                        <label>
                            {getCheckboxField('layoutApply', rentvine.layout.layoutApply, handleInputChange)}
                            Apply
                        </label>
                    </div>
                    <div className='mjwi-col33'>
                        
                    </div>
                </div>
            </div>

            <div className='mjwi-row'>
                <div className='mjwi-col50'>
                    <label>Section Background</label>
                </div>
                <div className='mjwi-col50 mjwi-clr-picker'>
                    <span 
                        className="clrPickerVal" 
                        onClick={toggleColorPicker} 
                        style={{ backgroundColor: rentvine.layout.layoutSectionBg }}
                    ></span>
                    <HexAlphaColorPicker 
                        color={rentvine.layout.layoutSectionBg} 
                        onChange={setSectionBg} 
                        style={{display: "none"}} 
                        className="mjwi-apfl-color-picker" 
                    />
                    <HexColorInput 
                        color={rentvine.layout.layoutSectionBg} 
                        onChange={setSectionBg} 
                    />
                </div>
            </div>

            {rentvine.layout.layoutRent === 'on' && (
                <>
                    <div className='mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Rent Color</label>
                        </div>
                        <div className='mjwi-col50 mjwi-clr-picker'>
                            <span 
                                className="clrPickerVal" 
                                onClick={toggleColorPicker} 
                                style={{ backgroundColor: rentvine.layout.layoutRentColor }}
                            ></span>
                            <HexAlphaColorPicker 
                                color={rentvine.layout.layoutRentColor} 
                                onChange={setRentColor} 
                                style={{display: "none"}} 
                                className="mjwi-apfl-color-picker" 
                            />
                            <HexColorInput 
                                color={rentvine.layout.layoutRentColor} 
                                onChange={setRentColor} 
                            />
                        </div>
                    </div>

                    <div className='mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Rent Background</label>
                        </div>
                        <div className='mjwi-col50 mjwi-clr-picker'>
                            <span 
                                className="clrPickerVal" 
                                onClick={toggleColorPicker} 
                                style={{ backgroundColor: rentvine.layout.layoutRentBg }}
                            ></span>
                            <HexAlphaColorPicker 
                                color={rentvine.layout.layoutRentBg} 
                                onChange={setRentBgColor} 
                                style={{display: "none"}} 
                                className="mjwi-apfl-color-picker" 
                            />
                            <HexColorInput 
                                color={rentvine.layout.layoutRentBg} 
                                onChange={setRentBgColor} 
                            />
                        </div>
                    </div>
                </>
            )}

            {rentvine.layout.layoutDate === 'on' && (
                <>
                    <div className='mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Date Color</label>
                        </div>
                        <div className='mjwi-col50 mjwi-clr-picker'>
                            <span 
                                className="clrPickerVal" 
                                onClick={toggleColorPicker} 
                                style={{ backgroundColor: rentvine.layout.layoutDateColor }}
                            ></span>
                            <HexAlphaColorPicker 
                                color={rentvine.layout.layoutDateColor} 
                                onChange={setDateColor} 
                                style={{display: "none"}} 
                                className="mjwi-apfl-color-picker" 
                            />
                            <HexColorInput 
                                color={rentvine.layout.layoutDateColor} 
                                onChange={setDateColor} 
                            />
                        </div>
                    </div>

                    <div className='mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Date Background</label>
                        </div>
                        <div className='mjwi-col50 mjwi-clr-picker'>
                            <span 
                                className="clrPickerVal" 
                                onClick={toggleColorPicker} 
                                style={{ backgroundColor: rentvine.layout.layoutDateBg }}
                            ></span>
                            <HexAlphaColorPicker 
                                color={rentvine.layout.layoutDateBg} 
                                onChange={setDateBgColor} 
                                style={{display: "none"}} 
                                className="mjwi-apfl-color-picker" 
                            />
                            <HexColorInput 
                                color={rentvine.layout.layoutDateBg} 
                                onChange={setDateBgColor} 
                            />
                        </div>
                    </div>
                </>
            )}

            {rentvine.layout.layoutTitle === 'on' && (
                <div className='mjwi-row'>
                    <div className='mjwi-col50 mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Title</label>
                            &nbsp;
                        </div>
                        <div className='mjwi-col50 mjwi-row'>
                            <div className='mjwi-col90 mjwi-row'>
                                <input
                                    type="number"
                                    name="layoutTitleSize"
                                    value={rentvine.layout.layoutTitleSize}
                                    onChange={handleInputChange}
                                />&nbsp;px
                            </div>
                            <div className='mjwi-col10'>
                            </div>
                        </div>
                    </div>
                    <div className='mjwi-col50 mjwi-clr-picker'>
                        <span 
                            className="clrPickerVal" 
                            onClick={toggleColorPicker} 
                            style={{ backgroundColor: rentvine.layout.layoutTitleColor }}
                        ></span>
                        <HexAlphaColorPicker 
                            color={rentvine.layout.layoutTitleColor} 
                            onChange={setTitleColor} 
                            style={{display: "none"}} 
                            className="mjwi-apfl-color-picker" 
                        />
                        <HexColorInput 
                            color={rentvine.layout.layoutTitleColor} 
                            onChange={setTitleColor} 
                        />
                    </div>
                </div>
            )}

            {rentvine.layout.layoutAddress === 'on' && (
                <div className='mjwi-row'>
                    <div className='mjwi-col50 mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Address</label>
                            &nbsp;
                        </div>
                        <div className='mjwi-col50 mjwi-row'>
                            <div className='mjwi-col90 mjwi-row'>
                                <input
                                    type="number"
                                    name="layoutAddressSize"
                                    value={rentvine.layout.layoutAddressSize}
                                    onChange={handleInputChange}
                                />&nbsp;px
                            </div>
                            <div className='mjwi-col10 mjwi-row'>
                            </div>
                        </div>
                    </div>
                    <div className='mjwi-col50 mjwi-clr-picker'>
                        <span 
                            className="clrPickerVal" 
                            onClick={toggleColorPicker} 
                            style={{ backgroundColor: rentvine.layout.layoutAddressColor }}
                        ></span>
                        <HexAlphaColorPicker 
                            color={rentvine.layout.layoutAddressColor} 
                            onChange={setAddressColor} 
                            style={{display: "none"}} 
                            className="mjwi-apfl-color-picker" 
                        />
                        <HexColorInput 
                            color={rentvine.layout.layoutAddressColor} 
                            onChange={setAddressColor} 
                        />
                    </div>
                </div>
            )}

            {rentvine.layout.layoutBeds === 'on' && (
                <>
                    <div className='mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Bed Icon Color</label>
                        </div>
                        <div className='mjwi-col50 mjwi-clr-picker'>
                            <span 
                                className="clrPickerVal" 
                                onClick={toggleColorPicker} 
                                style={{ backgroundColor: rentvine.layout.layoutBedIconColor }}
                            ></span>
                            <HexAlphaColorPicker 
                                color={rentvine.layout.layoutBedIconColor} 
                                onChange={setBedIconColor} 
                                style={{display: "none"}} 
                                className="mjwi-apfl-color-picker" 
                            />
                            <HexColorInput 
                                color={rentvine.layout.layoutBedIconColor} 
                                onChange={setBedIconColor} 
                            />
                        </div>
                    </div>
                    <div className='mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Bed Text Color</label>
                        </div>
                        <div className='mjwi-col50 mjwi-clr-picker'>
                            <span 
                                className="clrPickerVal" 
                                onClick={toggleColorPicker} 
                                style={{ backgroundColor: rentvine.layout.layoutBedColor }}
                            ></span>
                            <HexAlphaColorPicker 
                                color={rentvine.layout.layoutBedColor} 
                                onChange={setBedColor} 
                                style={{display: "none"}} 
                                className="mjwi-apfl-color-picker" 
                            />
                            <HexColorInput 
                                color={rentvine.layout.layoutBedColor} 
                                onChange={setBedColor} 
                            />
                        </div>
                    </div>
                </>
            )}

            {rentvine.layout.layoutBaths === 'on' && (
                <>
                    <div className='mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Bath Icon Color</label>
                        </div>
                        <div className='mjwi-col50 mjwi-clr-picker'>
                            <span 
                                className="clrPickerVal" 
                                onClick={toggleColorPicker} 
                                style={{ backgroundColor: rentvine.layout.layoutBathIconColor }}
                            ></span>
                            <HexAlphaColorPicker 
                                color={rentvine.layout.layoutBathIconColor} 
                                onChange={setBathIconColor} 
                                style={{display: "none"}} 
                                className="mjwi-apfl-color-picker" 
                            />
                            <HexColorInput 
                                color={rentvine.layout.layoutBathIconColor} 
                                onChange={setBathIconColor} 
                            />
                        </div>
                    </div>
                    <div className='mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Bath Text Color</label>
                        </div>
                        <div className='mjwi-col50 mjwi-clr-picker'>
                            <span 
                                className="clrPickerVal" 
                                onClick={toggleColorPicker} 
                                style={{ backgroundColor: rentvine.layout.layoutBathColor }}
                            ></span>
                            <HexAlphaColorPicker 
                                color={rentvine.layout.layoutBathColor} 
                                onChange={setBathColor} 
                                style={{display: "none"}} 
                                className="mjwi-apfl-color-picker" 
                            />
                            <HexColorInput 
                                color={rentvine.layout.layoutBathColor} 
                                onChange={setBathColor} 
                            />
                        </div>
                    </div>
                </>
            )}

            {rentvine.layout.layoutDetail === 'on' && (
                <>
                    <div className='mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Details Btn Color</label>
                        </div>
                        <div className='mjwi-col50 mjwi-clr-picker'>
                            <span 
                                className="clrPickerVal" 
                                onClick={toggleColorPicker} 
                                style={{ backgroundColor: rentvine.layout.layoutDetailColor }}
                            ></span>
                            <HexAlphaColorPicker 
                                color={rentvine.layout.layoutDetailColor} 
                                onChange={setDetailBtnColor} 
                                style={{display: "none"}} 
                                className="mjwi-apfl-color-picker" 
                            />
                            <HexColorInput 
                                color={rentvine.layout.layoutDetailColor} 
                                onChange={setDetailBtnColor} 
                            />
                        </div>
                    </div>
                    <div className='mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Details Btn BG</label>
                        </div>
                        <div className='mjwi-col50 mjwi-clr-picker'>
                            <span 
                                className="clrPickerVal" 
                                onClick={toggleColorPicker} 
                                style={{ backgroundColor: rentvine.layout.layoutDetailBg }}
                            ></span>
                            <HexAlphaColorPicker 
                                color={rentvine.layout.layoutDetailBg} 
                                onChange={setDetailBtnBgColor} 
                                style={{display: "none"}} 
                                className="mjwi-apfl-color-picker" 
                            />
                            <HexColorInput 
                                color={rentvine.layout.layoutDetailBg} 
                                onChange={setDetailBtnBgColor} 
                            />
                        </div>
                    </div>
                </>
            )}

            {rentvine.layout.layoutApply === 'on' && (
                <>
                    <div className='mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Apply Btn Color</label>
                        </div>
                        <div className='mjwi-col50 mjwi-clr-picker'>
                            <span 
                                className="clrPickerVal" 
                                onClick={toggleColorPicker} 
                                style={{ backgroundColor: rentvine.layout.layoutApplyColor }}
                            ></span>
                            <HexAlphaColorPicker 
                                color={rentvine.layout.layoutApplyColor} 
                                onChange={setApplyBtnColor} 
                                style={{display: "none"}} 
                                className="mjwi-apfl-color-picker" 
                            />
                            <HexColorInput 
                                color={rentvine.layout.layoutApplyColor} 
                                onChange={setApplyBtnColor} 
                            />
                        </div>
                    </div>
                    <div className='mjwi-row'>
                        <div className='mjwi-col50'>
                            <label>Apply Btn BG</label>
                        </div>
                        <div className='mjwi-col50 mjwi-clr-picker'>
                            <span 
                                className="clrPickerVal" 
                                onClick={toggleColorPicker} 
                                style={{ backgroundColor: rentvine.layout.layoutApplyBg }}
                            ></span>
                            <HexAlphaColorPicker 
                                color={rentvine.layout.layoutApplyBg} 
                                onChange={setApplyBtnBgColor} 
                                style={{display: "none"}} 
                                className="mjwi-apfl-color-picker" 
                            />
                            <HexColorInput 
                                color={rentvine.layout.layoutApplyBg} 
                                onChange={setApplyBtnBgColor} 
                            />
                        </div>
                    </div>

                    <div className='mjwi-row'>
                        <div className='mjwi-col33'>
                            <label>Apply Link</label>
                        </div>
                        <div className='mjwi-col66'>
                            <input
                                type="text"
                                placeholder="Leave blank for default link."
                                name="layoutApplyLink"
                                value={rentvine.layout.layoutApplyLink}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Content;